import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';

export interface NavItem {
  label: string;
  svg: string;
  inActiveSvg: SafeHtml;
  route: string;
  exact?: boolean;
}

@Component({
  selector: 'app-bottom-navbar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './mob-bottom-nav.component.html',
  styleUrls: ['./mob-bottom-nav.component.scss']
})
export class BottomNavbarComponent {
  @Input() navItems: NavItem[] = [];

  constructor(public router: Router) {}

  isActive(route: string): boolean {
    return this.router.url.includes(route);
  }

  navigate(route: string) {
    this.router.navigate([route]);
  }
}